<template>
  <b-modal ok-only id="common-modal" :title="title">
    <p class="my-4 text-center">{{body}}</p>
  </b-modal>
</template>
<script>
export default {
  name: 'CommonModal',
  props: {
    'title': String,
    'body': String
  },
  methods: {
    confirmBox (msg, afterExe = null, buttonText = '確認', dialogAddClass = '', modalsize = 'sm') {
      // Set the modalsize of the modal's width. 'sm', 'md', 'lg', or 'xl'
      this.$bvModal.msgBoxOk(msg, {
        title: '',
        size: modalsize,
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: buttonText,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        //  align-items-start
        centered: true,
        dialogClass: 'align-items-start t-10r ' + dialogAddClass
      }).then(value => {
        this.boxTwo = value
        if (afterExe) {
          this.$emit('confirmOk')
        }
      }).catch(err => {
        console.log(err)
        // An error occurred
      })
    },
    confirmBoxOkCancel (msg, args = null) {
      this.$bvModal.msgBoxConfirm(msg, {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'OK',
        cancelTitle: 'キャンセル',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false,
        centered: true,
        dialogClass: 'align-items-start t-10r'
      }).then(isOk => {
        if (isOk) {
          if (args) {
            this.$emit('confirmOk', args)
          } else {
            this.$emit('confirmOk')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommonModal.vue